import { render, staticRenderFns } from "./Spedy.vue?vue&type=template&id=58e4f43a&"
import script from "./Spedy.vue?vue&type=script&lang=js&"
export * from "./Spedy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports